export { default as withAuth0 } from './withAuth0';
//# sourceMappingURL=index.js.map